import { render, staticRenderFns } from "./PaymentAssistanceRequest.vue?vue&type=template&id=2c13167a&scoped=true"
import script from "./PaymentAssistanceRequest.vue?vue&type=script&lang=js"
export * from "./PaymentAssistanceRequest.vue?vue&type=script&lang=js"
import style0 from "./PaymentAssistanceRequest.vue?vue&type=style&index=0&id=2c13167a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c13167a",
  null
  
)

export default component.exports